import { GetPatients } from 'domain/usecases/patient/get-patients'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteGetPatients implements GetPatients {
  private readonly patientNewRepository: PatientNewRepository

  constructor(patientNewRepository: PatientNewRepository) {
    this.patientNewRepository = patientNewRepository
  }

  get(params: GetPatients.Params): Promise<GetPatients.Model> {
    return this.patientNewRepository.getPatients(params)
  }
}
